import React, { useState, useEffect } from 'react';
import API from '@scale/frontend-lib/dashboard-api';
import { defaultApiFetchErrorHandler } from '@scale/frontend-lib/api-fetch';
interface ImageSectionProps {
  attributes: $FIXME;
  children: Record<string, any>[];
  element: $FIXME;
}
// Used for images and PDFs
export const ImageSection: React.FC<ImageSectionProps> = ({ attributes, children, element }) => {
  const { assetId } = element;
  const [asset, setAsset] = useState<any>(null);

  useEffect(() => {
    async function fetchData() {
      try {
        const asset = await API.selfserve.fetchInstructionAssetS3URL({ assetId });
        if (asset) {
          setAsset(asset);
        }
      } catch (e) {
        defaultApiFetchErrorHandler(e, { handleHttp: true });
      }
    }
    fetchData();
  }, [assetId]);

  return (
    <div className="imageContainer" {...attributes}>
      <div contentEditable={false} style={{ display: 'flex' }}>
        {!asset ? (
          <div>loading...</div>
        ) : (
          <>
            {asset!.mimeType === 'application/pdf' ? (
              <object
                data={asset!.signedURL + '#toolbar=0'}
                type="application/pdf"
                width="100%"
                height="800"
              ></object>
            ) : (
              <img src={asset!.signedURL} />
            )}
          </>
        )}
      </div>
      {children}
      <style jsx>{`
        .button {
          opacity: 0;
          position: relative;
          right: -33%;
          top: -12px;
        }
        .imageContainer:hover .button {
          opacity: 1;
        }
      `}</style>
    </div>
  );
};
